import { ACTIONS_ACCOUNT } from '../_constants/account.constants';

const initialState = {
  byId: {},
};

export function accountReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_ACCOUNT.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_ACCOUNT.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_ACCOUNT.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default accountReducer;
